import { render } from "./addReturns.vue?vue&type=template&id=c254d12c&scoped=true"
import script from "./addReturns.vue?vue&type=script&lang=js"
export * from "./addReturns.vue?vue&type=script&lang=js"

import "./addReturns.vue?vue&type=style&index=0&id=c254d12c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c254d12c"

export default script